import { CARD_LABEL_COMMON } from "./common.type"

export const OVERALL_CARDS_TYPE = {
    INSURANCE_DATA: 'insuranceData',
    DOCTOR_DATA: 'doctorData',
    FLOORS_DATA: 'floorsData',
    NINETY_DAYS_DATA: 'ninetyDaysData',
    DAYS_DATA: 'daysData',
    EXHUAST_INSURANCE_DATA: 'exhaustInsuranceData',
    TOTAL: "total",
    TOTAL_INCOMING: 'totalIncoming',
    TOTAL_OUTGOING: 'totalOutgoing',
    EXHUST_AVARAGE_DATA: 'exhaustAverageData',
}

export const OVERALL_CARDS_LABELS = {
    insuranceData: CARD_LABEL_COMMON.perInsurance,
    doctorData: CARD_LABEL_COMMON.perDoctor,
    floorsData: CARD_LABEL_COMMON.perFloor,
    daysData: CARD_LABEL_COMMON.perDay,
    ninetyDaysData: '90 Days Analysis',    
    totalIncoming: "Total Incoming",
    totalOutgoing: "Total Outgoing",
    totalMain : "Total +/-",
    exhaustInsuranceData: "Medicare Exhaust",
    exhaustAverageData: "Medicare Exhaust: Avg. Length of Stay",
}